/*
 * Filename: template-config-controllers.ts
 * Description: template cofig controler.
 */

import { CQAPIService } from '../../../services/http-api.service';
import { TemplateSFObjectStore, ITemplateSFObjectStore } from '../../../store/models/template-object.model';
import { LSTemplatesStore } from '../../../store/ls-template-store';
import { CQAppStore } from '../../../store/cq-app-store';
import FileSaver from 'file-saver';
import { CQAppConstant } from '../../../app-constants';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { UserDetailsStore, IUserDetailsStore } from '../../../store/user-details.store';
import Cookies from 'universal-cookie';
import { VisibleRuleHeaderActionsController } from '../../../common/rules/header-actions/visibility-rule.controller';
import { VisibleRuleRowActionsController } from '../../../common/rules/row-actions/visibility-rule.controller';

interface FieldObject {
    [key: string]: any
}

export default class GridTemplateConfigurationController {
    public getCookieValue = (key: string) => {
        return this.cookie.get(key);
    }

    /**
     * sets the prefixname to local storage or global store conditionally depending upon setstore
     * @param {string} templateName stores the name of the selected template
     * @param {boolean} setStore if true then updates the store value of prefix
     * @param {string} prefixValue stores the value of prefix of selected template
     * @memberof TemplateConfigurationController
     */
    public setPrefixName = (templateName: string, setStore: boolean = true, prefixValue?: string) => {
        let orgId = this.getCookieValue(CQAppConstant.LOGGED_IN_ORG_ID);
        let stringPrefixNames: any = localStorage.getItem('prefixName');
        if (!stringPrefixNames) {
            stringPrefixNames = JSON.stringify({});
        }
        let prefixNames = JSON.parse(stringPrefixNames);
        if (prefixValue) {
            prefixNames[orgId] = prefixValue;
            localStorage.setItem('prefixName', JSON.stringify(prefixNames));
        }
        
        if (setStore === true) {
            this.updateFieldValue('prefix', prefixNames[orgId], templateName);
        }
    }
    
    private readonly cqAPIService: CQAPIService;
    // public templateSFObjectStore: ITemplateSFObjectStore;
    public userDetailsStore: IUserDetailsStore;
    private readonly cookie: Cookies;
    constructor() {
        this.cqAPIService = new CQAPIService();
        //this.templateSFObjectStore = TemplateSFObjectStore.create({ sfObjects: [], templateLayouts: [] });
        this.userDetailsStore = UserDetailsStore;
        this.cookie = new Cookies();
    }

    /**
     * @memberof GridTemplateConfigurationController
     */
    public getObjects() {
        try {
            CQAppStore.loader.setVisibility(true);
            this.cqAPIService.getObjects().then((objects) => {
                TemplateSFObjectStore.loadSFObjects(this.filterObjects(objects.sobjects));
                CQAppStore.loader.setVisibility(false);
            });
        } catch (error) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: "GridTemplateConfigurationController"
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    public getSelectedObject(templateName: string) {
        return CQMasterDataStore.OutputConfig.getSelectedObject(templateName);
    }

    public setSelectedObject(templateName: string, objectName: string) {
        CQMasterDataStore.OutputConfig.setSelectedObject(templateName, objectName);
    }

    /**
     * @param {string} objectName
     * @memberof GridTemplateConfigurationController
     */
    public async getObjectFields(objectName: string, hasParent: boolean) {

        try {
            CQAppStore.loader.setVisibility(true);
            await this.cqAPIService.getApiObjectFields(objectName, hasParent).then((objectFields) => {
                if (objectFields) {
                    TemplateSFObjectStore.loadSFObjectFields(objectFields);
                }
                CQAppStore.loader.setVisibility(false);
            });
        } catch (error) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: "GridTemplateConfigurationController"
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    public async getAllObjectFields(objectName: string, hasParent: boolean, standardFieldIncludeFlag: boolean) {

        try {
            CQAppStore.loader.setVisibility(true);
            await this.cqAPIService.getApiObjectFields(objectName, hasParent, standardFieldIncludeFlag).then((objectFields) => {
                if (objectFields) {
                    objectFields.fields =  objectFields.fields.sort((a: any, b: any) => { return a.label > b.label ? 1 : (a.label === b.label ? 0 : -1); });
                    TemplateSFObjectStore.loadSFStandardObjectFields(objectFields);
                }
                CQAppStore.loader.setVisibility(false);
            });
        } catch (error) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: "GridTemplateConfigurationController"
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    /**
     * @param {string} templateName
     * @param {string} objectName
     * @memberof GridTemplateConfigurationController
     */
    public setObject(templateName: string, objectName: string) {
        CQMasterDataStore.OutputConfig.setSelectedObject(templateName, objectName);
    }

    /**
     * @param {string} templateName
     * @param {string} layoutId
     * @memberof GridTemplateConfigurationController
     */
    public setLayout(templateName: string, layoutId: string) {
        CQMasterDataStore.OutputConfig.setSelectedLayout(templateName, layoutId);
    }

    /**
     * @param {string} selectedLayoutName
     * @param {string} objectName
     * @param {string} TableEnumOrId
     * @memberof GridTemplateConfigurationController
     */
    public getReferenceObjectFields(selectedObjectField: string, hasParent: boolean,includeStandardFieldFlag:boolean) {
        try {
            CQAppStore.loader.setVisibility(true);
            this.cqAPIService.getApiObjectFields(selectedObjectField, hasParent,includeStandardFieldFlag).then((referenceObjectFields: any) => {
                if (referenceObjectFields) {
                    referenceObjectFields.fields = referenceObjectFields.fields.sort((a: any, b: any) => { return a.label > b.label ? 1 : (a.label === b.label ? 0 : -1); });
                    TemplateSFObjectStore.loadReferenceObjectFields(referenceObjectFields);
                }
                CQAppStore.loader.setVisibility(false);
            });
        } catch (error) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: "GridTemplateConfigurationController"
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    /**
     * @param {string} selectedLayoutName
     * @param {string} objectName
     * @param {string} TableEnumOrId
     * @memberof GridTemplateConfigurationController
     */
    public getMainReferenceObjectFields(selectedObjectField: string, hasParent: boolean,includeStandardFieldFlag:boolean) {
        try {
            CQAppStore.loader.setVisibility(true);
            this.cqAPIService.getApiObjectFields(selectedObjectField, hasParent,includeStandardFieldFlag).then((referenceObjectFields: any) => {
                if (referenceObjectFields) {
                    referenceObjectFields.fields = referenceObjectFields.fields.sort((a: any, b: any) => { return a.label > b.label ? 1 : (a.label === b.label ? 0 : -1); });
                    TemplateSFObjectStore.loadMainReferenceObjectFields(referenceObjectFields);
                }
                CQAppStore.loader.setVisibility(false);
            });
        } catch (error) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: "GridTemplateConfigurationController"
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    /**
     * @param {*} layoutMetaData
     * @returns
     * @memberof GridTemplateConfigurationController
     */
    public getUpdateLayoutData(layoutMetaData: any) {
        const layoutSections: any[] = [];
        const layoutFields: any[] = [];
        layoutMetaData.layout.layoutSections.forEach((layoutSection: any) => {
            if (layoutSection.detailHeading === true || layoutSection.editHeading === true) {
                layoutSections.push(layoutSection);
                layoutSection.columnSize = layoutSection.layoutColumns.length;
                let maxColumnSize = 0;
                // find the column with maximum number of fields/form items, so that we can iterate and create a single list from multi columns.
                layoutSection.layoutColumns.forEach(function (e: any) {
                    if (e.layoutItems && e.layoutItems.length > maxColumnSize) {
                        maxColumnSize = e.layoutItems.length;
                    }
                });
                const { updatedlayoutFields, layoutItems } = this.getUpdatedLayoutFields(maxColumnSize, layoutSection);
                layoutFields.push(...updatedlayoutFields);
                layoutSection.layoutColumns = layoutItems;
            }
        });
        return { layoutSections, layoutFields };
    }

    /**
     * @memberof GridTemplateConfigurationController
     */
    public updateFieldValue = (fieldKey: string, fieldValue: any, templatName: string) => {
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templatName, fieldKey, fieldValue);
    }

    public getLWCComponentList = async (searchKey?: string) => {
        if (searchKey) {
            return await this.cqAPIService.getAllLWCComponent(searchKey);
        }
        return await this.cqAPIService.getAllLWCComponent();
    }

    public getVFPageComponentList = async (searchText?:string) => {
        if(searchText){
            return await this.cqAPIService.getAllVFPageComponent(searchText);
        }
        return await this.cqAPIService.getAllVFPageComponent();
    }

    public getUpdatedLayoutFields(maxColumnSize: number, layoutSection: any) {
        let index = 0, columnIndex = 0;
        const updatedlayoutFields: any[] = [];
        const layoutItems: any = [];
        for (; index < maxColumnSize; index++) {
            for (columnIndex = 0; columnIndex < layoutSection.columnSize; columnIndex++) {
                const sectionItem = layoutSection.layoutColumns[columnIndex].layoutItems[index] || { emptySpace: true };
                layoutItems.push(sectionItem);
                if (sectionItem.field) {
                    updatedlayoutFields.push(sectionItem.field);
                }
            }
        }
        return { updatedlayoutFields, layoutItems };
    }

    public filterObjects(sobjects: any) {
        if (sobjects && sobjects.length !== 0) {
            sobjects = sobjects.sort((a: any, b: any) => { return a.label > b.label ? 1 : (a.label === b.label ? 0 : -1); });
            return sobjects.filter((sObject: any) => {
                return sObject.createable && sObject.custom;
            }).map((filteredSObject: any) => {
                filteredSObject.label = `${filteredSObject.label} ( ${filteredSObject.name} )`;
                return filteredSObject;
            });
        }
        return [];
    }

    public getSelectedTemplate() {
        let template: any = LSTemplatesStore.selectedTemplate;

        if (template.hasOwnProperty('selectedTemplate')) {
            template = template.selectedTemplate;
        }
        return template;
    }

    public isLayoutFieldAvailable() {
        let template: any = LSTemplatesStore.selectedTemplate;
        if (template.hasOwnProperty('selectedTemplate')) {
            template = template.selectedTemplate;
        }
        if (template.inputParams.layout) {
            return true;
        }
        return false;
    }

    public getTemplateWiseFormData(templateName: string) {
        return CQMasterDataStore.OutputConfig.getStoreData(templateName);
    }

    /**
     * @param {string} templateName
     * @memberof GridTemplateConfigurationController
     */
    public downloadLWC(templateName: string) {
        try {
            this.getAddtionalFieldsFromRules(templateName);
            const outputConfigData = this.getTemplateWiseFormData(templateName);
            const versionNumber = this.cookie.get(CQAppConstant.VERSION_NUMBER);
            if (outputConfigData) {
                const metadata = JSON.parse(JSON.stringify(outputConfigData));
                CQAppStore.loader.setVisibility(true);
                this.cqAPIService.downloadLWC(versionNumber, templateName, metadata).then((res) => {

                    if (res) {
                        CQAppStore.loader.setVisibility(false);
                        return res.blob();
                    }
                }).then((templateZipBlob) => {
                    if (templateZipBlob) {
                        FileSaver.saveAs(templateZipBlob, CQAppConstant.DOWNLOADABLE_ZIP_FILE_NAME);
                    }
                });
            }
        }
        catch (e) {

            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: "GridTemplateConfigurationController"
            };
            CQAppStore.error.dispatchError(errorObj);
        }

    }

    /**
     * @param {string} templateName
     * @memberof GridTemplateConfigurationController
     */
    public publishLWC(templateName: string) {
        try {
            const outputConfigData = this.getTemplateWiseFormData(templateName);
            const versionNumber = this.cookie.get(CQAppConstant.VERSION_NUMBER);
            if (outputConfigData) {
                const metadata = JSON.parse(JSON.stringify(outputConfigData));
                CQAppStore.loader.setVisibility(true);
                this.cqAPIService.publishLWC(versionNumber, templateName, metadata).then((res) => {

                    CQAppStore.loader.setVisibility(false);
                    const successObj = {
                        successMessage: "Package is deployed successfully",
                        componentName: 'GridTemplateConfigurationController',
                    };
                    CQAppStore.success.dispatchError(successObj);
                    return res;
                });
            }
        } catch (e) {

            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: "Something went wrong",
                componentName: ""
            };
            CQAppStore.error.dispatchError(errorObj);
        }

    }

    public getAddtionalFieldsFromRules = (selectedTemplateName:string) => {
        //const ruleElements: any = CQMasterDataStore.RuleElements.FieldRuleElement;
        const outputConfig = CQMasterDataStore.OutputConfig;
        const ruleElements: any = outputConfig.getStoreKeyData(selectedTemplateName, 'ruleElements');
        let additionalFields: any[] = [];
        const gridObject: any = ruleElements.gridObject;
        Object.keys(gridObject).length && Object.keys(gridObject).map((currentKey) => {
            if (gridObject[currentKey].additionalFieldsArray.length > 0) {
                const fields = gridObject[currentKey].additionalFieldsArray;
                additionalFields = [...additionalFields, ...fields];
            }
        });
        additionalFields = Array.from(new Set(additionalFields));
        return additionalFields
    }

    /**
     * @param {string} templatName
     * @param {string} key
     * @param {string} value
     * @memberof GridTemplateConfigurationController
     */
    public updateFormData(templatName: string, key: string, value: string) {
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templatName, key, value);
    }

    /**
     * @param {string} templatName
     * @param {string} key
     * @param {*} layoutMetaData
     * @memberof GridTemplateConfigurationController
     */
    public updateLayoutMetaData(templatName: string, key: string, layoutMetaData: any) {
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templatName, key, layoutMetaData);
    }

    public async loginToDifferentOrg(oAuthRequest: any) {
        this.cqAPIService.login(oAuthRequest).then(async (connection : any) => {
            try {
                if (connection && connection.accessToken) {
                    this.publishLWCToOtherOrg(connection.accessToken, connection.instanceUrl);
                }
            }
            catch (error) {
                CQAppStore.loader.setVisibility(false);
                const errorObj = {
                    errorType: CQAppConstant.ERROR_CUSTOM,
                    errorMessage: "Something went wrong",
                    componentName: "CQLogin"
                };
                CQAppStore.error.dispatchError(errorObj);
            }
        });
    }

    public initializeStandardRowState = () => {
        return {
            isApplyRuleModalVisisble: false,
            isFormValid: false,
            rowActionType: 'standard_row_action',
            isRuleApplied: false,
            visibilityRuleObj: {},
            visibilityRuleFields: [],
            isVisible: '',
            label: '',
            parentFields: [],
            additionalFieldsArray: [],
            isActionSaved: true,
            name: ''
        };
    }

    /**
   * @param {string} templateName
   * @memberof GridTemplateConfigurationController
   */
    public async publishLWCToOtherOrg(sfAccessToken: string, instanceUrl: string) {
        try {
            // const template: any = this.getSelectedTemplate();
            // // const jwtToken = await this.cqAPIService.authenicateUser(sfAccessToken);
            // // const token = JSON.parse(JSON.stringify(jwtToken)).token;
            // // const token = JSON.parse(JSON.stringify(jwtToken)).token;
            // const outputConfigData = this.getTemplateWiseFormData(template.name);
            // const versionNumber = this.cookie.get(CQAppConstant.VERSION_NUMBER);
            // if (outputConfigData) {
            //     const metadata = JSON.parse(JSON.stringify(outputConfigData));
            //     CQAppStore.loader.setVisibility(true);
            //     this.cqAPIService.publishLWCToOtherOrg(versionNumber, template.name, metadata, instanceUrl, sfAccessToken, environment).then((res:any) => {
            //         CQAppStore.loader.setVisibility(false);
            //         const successObj = {
            //             successMessage: 'Package is deployed successfully',
            //             componentName: 'GridTemplateConfigurationController',
            //         };
            //         CQAppStore.success.dispatchError(successObj);
            //         return res;
            //     });
            // }
        } catch (e) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: 'Something went wrong',
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    public getRuleController = (ruleObject: any) => {
        const ruleObj: any = new VisibleRuleHeaderActionsController(ruleObject);
        return ruleObj.ruleJSON;
    };

    public resetCustomAction(actionName: string, templateName: string) {
        const outputConfig = CQMasterDataStore.OutputConfig;
        let ruleElements: any = outputConfig.getStoreKeyData(templateName, 'ruleElements');
        if (ruleElements.hasOwnProperty('gridObject')) {
            let gridObject = JSON.parse(JSON.stringify(ruleElements.gridObject));
            const isActionNamePresent = gridObject.hasOwnProperty('headerActions') && gridObject.headerActions.hasOwnProperty(actionName);
            if(isActionNamePresent){
                delete gridObject.headerActions[actionName];
            }
            ruleElements.gridObject = gridObject;
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'ruleElements', ruleElements);
            // CQMasterDataStore.RuleElements.addGridObject(ruleElements);
        }
        const templateObject = outputConfig.getStoreData(templateName);
        let headerActions = [...templateObject.headerActions];
        let itemIndex: any;
        headerActions.length && headerActions.map((action: any, index: number) => {
            if (action.name === actionName) {
                itemIndex = index
            }
        });
        if (headerActions.length > 1) {
            headerActions.splice(itemIndex, 1);
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'headerActions', headerActions);
        } else {
            headerActions = [];
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'headerActions', headerActions);
        }
        let headerFormRules = { ...templateObject.headerFormRules };
        if (headerFormRules.hasOwnProperty(actionName)) {
            delete headerFormRules[actionName];
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'headerFormRules', headerFormRules);
        }
        CQMasterDataStore.GridObject.updateGridField('selectedAction', 'customHeaderAction');
        let orderedHeaderActions = [...CQMasterDataStore.GridObject.orderedHeaderActions];
        let actionIndex: any;
        orderedHeaderActions.forEach((orderedAction: any, index: any) => {
            if (orderedAction.actionJSON && orderedAction.actionJSON.hasOwnProperty('headerActions') && orderedAction.actionJSON.headerActions.name === actionName) {
                actionIndex = index
            } else if (orderedAction.actionJSON.hasOwnProperty('headerFormRules') && orderedAction.actionJSON.headerFormRules.hasOwnPRoperty(actionName)) {
                actionIndex = index
            }
        });
        if (orderedHeaderActions.length > 1) {
            orderedHeaderActions.splice(actionIndex, 1);
        } else {
            orderedHeaderActions = [];
        }
        CQMasterDataStore.GridObject.updateGridField('orderedHeaderActions', orderedHeaderActions);
        let headerActionIndex: any;
        let headerActionTypes = [...CQMasterDataStore.GridObject.headerActionTypes];
        headerActionTypes.forEach((headerAction: any, index: any) => {
            if (headerAction.name === actionName) {
                headerActionIndex = index;
            }
        });
        if (headerActionTypes.length > 1) {
            headerActionTypes.splice(headerActionIndex, 1);
        } else {
            headerActionTypes = [];
        }
        CQMasterDataStore.GridObject.updateGridField('headerActionTypes', headerActionTypes);
    }


    public resetRowCustomAction(actionName: string, templateName: string) {
        // const ruleElements = { ...CQMasterDataStore.RuleElements.FieldRuleElement };
        const outputConfig = CQMasterDataStore.OutputConfig;
        let ruleElements: any = outputConfig.getStoreKeyData(templateName, 'ruleElements');
        if (ruleElements.hasOwnProperty('gridObject')) {
            let gridObject: any = { ...ruleElements.gridObject };
            if(gridObject.hasOwnProperty('rowActions')){
                let rowActions: any = { ...gridObject.rowActions };
                if(rowActions.hasOwnProperty(actionName)){
                    delete rowActions[actionName];
                }
                gridObject.rowActions = rowActions;
            }
            ruleElements.gridObject = gridObject;
            // CQMasterDataStore.RuleElements.addGridObject(ruleElements);
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'ruleElements', ruleElements);
        }
        const templateObject = outputConfig.getStoreData(templateName);
        let rowActions = [...templateObject.rowActions];
        let itemIndex: any;
        rowActions.length && rowActions.forEach((action: any, index: number) => {
            if (action.name === actionName) {
                itemIndex = index
            }
        });
        if (rowActions.length > 1) {
            rowActions.splice(itemIndex, 1);
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'rowActions', rowActions);
        } else {
            rowActions = [];
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'rowActions', rowActions);
        }
        let rowFormRules = { ...templateObject.rowFormRules };
        if (rowFormRules.hasOwnProperty(actionName)) {
            delete rowFormRules[actionName];
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'rowFormRules', rowFormRules);
        }
        let orderedRowActions = [...CQMasterDataStore.GridObject.orderedRowAction];
        let actionIndex: any;
        orderedRowActions.forEach((orderedAction: any, index: any) => {
            if (orderedAction.actionJSON.hasOwnProperty('rowActions') && orderedAction.actionJSON.rowActions.name === actionName) {
                actionIndex = index
            } else if (orderedAction.actionJSON.hasOwnProperty('rowFormRules') && orderedAction.actionJSON.rowFormRules.hasOwnProperty(actionName)) {
                actionIndex = index
            }
        });
        if (orderedRowActions.length > 1) {
            orderedRowActions.splice(actionIndex, 1);
        } else {
            orderedRowActions = [];
        }
        CQMasterDataStore.GridObject.updateGridField('orderedRowActions', orderedRowActions);
        let rowActionIndex: any;
        let rowActionTypes = [...CQMasterDataStore.GridObject.rowActionTypes];
        rowActionTypes.forEach((rowAction: any, index: any) => {
            if (rowAction.name === actionName) {
                rowActionIndex = index;
            }
        });
        if (rowActionTypes.length > 1) {
            rowActionTypes.splice(rowActionIndex, 1);
        } else {
            rowActionTypes = [];
        }
        CQMasterDataStore.GridObject.updateGridField('rowActionTypes', rowActionTypes);
        CQMasterDataStore.GridObject.updateGridField('selectedAction', 'customRowAction');
    }

    public getVisibilityRuleController = (ruleObject: any) => {
        const ruleObj: any = new VisibleRuleRowActionsController(ruleObject);
        return ruleObj.ruleJSON;
    }
}
